export default __webpack_public_path__ + "static/media/vihari.90689859.png";